import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import {
  slidePrintRoutingService,
  type UpdateSlidePrintRoutingSettingsRequest,
} from "../../services/slidePrintRouting.service";

export const SLIDE_PRINT_ROUTING_QUERY_KEY = [
  "slide-print-routing-settings",
] as const;

export function useSlidePrintRoutingSettings(enabled = true) {
  return useQuery({
    queryKey: SLIDE_PRINT_ROUTING_QUERY_KEY,
    queryFn: slidePrintRoutingService.get,
    enabled,
  });
}

export function useUpdateSlidePrintRoutingSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: UpdateSlidePrintRoutingSettingsRequest) =>
      slidePrintRoutingService.update(request),
    onSuccess: (settings) => {
      queryClient.setQueryData(SLIDE_PRINT_ROUTING_QUERY_KEY, settings);
      notifications.show({
        title: "Slide printing updated",
        message: settings.changed
          ? "The new route applies to the next slide-label print."
          : "Slide printing was already using that route.",
        color: "green",
        autoClose: 4000,
      });
    },
    onError: () => {
      void queryClient.invalidateQueries({
        queryKey: SLIDE_PRINT_ROUTING_QUERY_KEY,
      });
      notifications.show({
        title: "Slide printing not changed",
        message:
          "The setting could not be saved. Review the latest value and try again.",
        color: "red",
        autoClose: 5000,
      });
    },
  });
}
